<div class="v3ndor-feature-wrapper" [ngClass]="currentThemeClass()">
  <div class="v-page-content">
    <app-ticket-log-active-filters
      [filters]="filters"
      [enableSavedFilters]="enableSavedFilters"
      [savedFilters]="savedFilters"
      [activeSavedFilterId]="activeSavedFilterId"
      (editFilters)="onEditFilters()"
      (removeFilter)="onFiltersChange($event)"
      (periodChange)="onPeriodChange($event)"
      (applySavedFilter)="onApplySavedFilter($event)"
      (deactivateSavedFilter)="onDeactivateSavedFilter()"
      (deleteSavedFilter)="onDeleteSavedFilter($event)">
      <!-- Um @if por botão: com mais de um nó na raiz, o Angular não projeta no
           slot nomeado (NG8011). -->
      @if (metrics && !metrics.isEmpty) {
        <button filtersActionsLeft type="button" class="tlh-toolbar-btn" (click)="openMetrics()">
          <i class="pi pi-chart-bar" aria-hidden="true"></i>
          <span>Métricas</span>
        </button>
      }
    </app-ticket-log-active-filters>

    <!-- Faixa de totais — sempre visível. Os números descrevem SÓ o recorte
         filtrado (usuário + período), nunca o histórico inteiro; por isso a
         frase de contexto vem junto e não é opcional. -->
    @if (metrics && !metrics.isEmpty) {
      <div class="tlh-summary">
        <div class="tlh-summary__context">{{ metrics.contexto }}</div>
        <div class="tlh-summary__cards">
          @for (card of metrics.cards; track card.key) {
            <div class="tlh-summary__card" [attr.data-severity]="card.severity">
              <span class="tlh-summary__value">{{ card.value }}</span>
              <span class="tlh-summary__label">{{ card.label }}</span>
            </div>
          }
        </div>
      </div>
    }

    <!-- Um total parcial exibido como se fosse completo é pior que não ter total. -->
    @if (registrosOmitidos > 0) {
      <div class="tlh-warning">
        <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
        <span>
          O período selecionado tem mais apontamentos do que esta tela consegue carregar de uma vez.
          <strong>{{ registrosOmitidos }}</strong> registro(s) ficaram de fora — os totais e o
          kanban abaixo descrevem apenas o que foi carregado. Reduza o intervalo de datas para ver
          tudo.
        </span>
      </div>
    }

    @if (loading) {
      <div class="tlh-loading">
        <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
        <span>Carregando apontamentos…</span>
      </div>
    } @else if (!metrics || metrics.isEmpty) {
      <!-- "Carregando" e "não há apontamento" são fatos opostos: sem esta
           distinção a tela afirma ausência durante toda a carga. -->
      <div class="tlh-empty">
        <i class="pi pi-clock" aria-hidden="true"></i>
        <p>Nenhum apontamento no recorte atual.</p>
      </div>
    } @else {
      <div class="tlh-board">
        @for (date of getObjectDateKeysAsNumbers(data); track date) {
          <div class="tlh-col">
            <div class="tlh-col__header">
              <span class="tlh-col__title">{{
                dateLabelToDate(date) | timeToDate: true : true
              }}</span>
              @if (getDayBucket(date); as dia) {
                <span class="tlh-col__meta">
                  <span class="tlh-col__duration">{{ dia.duracao }}</span>
                  <span class="tlh-col__tickets">{{ dia.chamados }} chamado(s)</span>
                </span>
              }
            </div>

            <!-- Barra de meta do dia, fora do header para ocupar a largura toda. -->
            @if (getDayBucket(date); as dia) {
              <div class="tlh-col__meter" [attr.title]="'Meta de ' + metrics.metaDiariaHoras + 'h'">
                <div
                  class="tlh-col__meter-fill"
                  [attr.data-severity]="dia.severity"
                  [style.width.%]="dia.percentMeta"></div>
              </div>
            }

            <div class="tlh-col__body">
              @for (ticket of data[date]; track ticket) {
                <app-ticket-log-card
                  [ticket]="ticket"
                  (cardClick)="openTicketLogs(ticket)"
                  (contextMenuRequest)="onCardContextMenu($event, ticket)">
                  <div class="tlh-logs">
                    <div class="tlh-logs__header">
                      <span class="tlh-logs__total">{{ getTicketDayTotal(date, ticket) }}</span>
                      <!-- Expande e recolhe TODOS os cards visíveis, não só este.
                           stopPropagation é obrigatório: o clique borbulha até o
                           card e abriria o modal junto. -->
                      <button
                        type="button"
                        class="tlh-logs__expand"
                        [attr.title]="
                          expandedAll ? 'Recolher todos os cards' : 'Expandir todos os cards'
                        "
                        [attr.aria-expanded]="expandedAll"
                        (click)="toggleExpandAll($event)">
                        <i
                          class="pi"
                          [class.pi-chevron-down]="!expandedAll"
                          [class.pi-chevron-up]="expandedAll"></i>
                      </button>
                    </div>

                    @for (ticketLog of ticket.ticket_logs; track ticketLog; let i = $index) {
                      <div
                        class="tlh-log"
                        [class.tlh-log--odd]="i % 2 !== 0"
                        [style.border-left-color]="getTypeColor(ticketLog.type)">
                        <div class="tlh-log__times">
                          <span class="tlh-log__range">
                            {{ ticketLog.start_date | date: 'HH:mm' }} –
                            {{ ticketLog.end_date | date: 'HH:mm' }}
                          </span>
                          <span class="tlh-log__duration">
                            {{ ticketLog.start_date | ticketLogTime: ticketLog.end_date }}
                          </span>
                        </div>

                        @if (expandedAll) {
                          @if (getTypeLabel(ticketLog.type)) {
                            <span
                              class="tlh-log__type"
                              [style.background-color]="getTypeColor(ticketLog.type)">
                              {{ getTypeLabel(ticketLog.type) }}
                            </span>
                          }
                          <!-- Descrição vazia com placeholder: uma linha em
                               branco some visualmente e parece bug. -->
                          @if (ticketLog.description) {
                            <div class="tlh-log__description">
                              {{ ticketLog.description | truncate: [255] }}
                            </div>
                          } @else {
                            <div class="tlh-log__description tlh-log__description--empty">
                              Sem descrição
                            </div>
                          }
                        }
                      </div>
                    }
                  </div>
                </app-ticket-log-card>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>

  <!-- Dentro do wrapper de propósito: os diálogos herdam as variáveis de tema
       daqui, e fora dele abririam sem cor. -->
  <app-ticket-log-filter-panel
    [visible]="filterPanelVisible"
    (visibleChange)="onFilterPanelVisibleChange($event)"
    [filters]="filters"
    [loading]="loading"
    [enableSavedFilters]="enableSavedFilters"
    (searchFilters)="onFiltersChange($event)"
    (saveFilter)="onSaveFilter($event)" />

  <!-- Dentro do wrapper de tema, como o painel: fora dele o diálogo de
       confirmação abriria sem as variáveis `--v-*`. -->
  <p-confirmDialog />
</div>

<!-- UM menu para o quadro inteiro; cada card só avisa que o botão direito foi
     acionado e a tela monta os itens para aquele chamado. -->
<p-contextMenu #ticketMenu [model]="contextMenuItems" appendTo="body" />

<app-time-entry-history-modal
  [ticketId]="selectedTicketId"
  [ticketNumber]="selectedTicketNumber"
  [visible]="historyModalVisible"
  (visibleChange)="onHistoryModalVisibleChange($event)" />

@if (metrics) {
  <app-time-entry-metrics-modal
    [model]="metrics"
    [visible]="metricsModalVisible"
    (visibleChange)="metricsModalVisible = $event"
    (sliceActivate)="onMetricSliceActivate($event)" />
}
